import { jsx, jsxs } from "react/jsx-runtime";
import "react";
import styled_components from "styled-components";
import { Box, Card, Flex, Image, Link, Relative, Text } from "pcln-design-system";
import { CarsOutline, FlightsOutline, HotelsOutline, PackagesOutline } from "@pcln/brand";
import { products, productsType } from "../../constants/index.js";
const StyledImage = /*#__PURE__*/ styled_components(Image).withConfig({
    displayName: "TripCard__StyledImage"
})([
    "object-fit:cover;"
]);
const CustomTruncate = /*#__PURE__*/ styled_components(Text).withConfig({
    displayName: "TripCard__CustomTruncate"
})([
    "width:100%;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;"
]);
const BackUpImage = ({ type })=>{
    let IconType;
    if ('STAY' === type) IconType = HotelsOutline;
    else if ('DRIVE' === type) IconType = CarsOutline;
    else if ('FLY' === type) IconType = FlightsOutline;
    else if ('PACKAGE' === type) IconType = PackagesOutline;
    return IconType ? /*#__PURE__*/ jsx(Card, {
        height: "100%",
        borderRadius: "8px",
        borderWidth: 0,
        color: "primary.light",
        children: /*#__PURE__*/ jsx(Flex, {
            width: [
                '48px',
                '88px'
            ],
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
            children: /*#__PURE__*/ jsx(IconType, {
                color: "primary",
                size: "32px"
            })
        })
    }) : null;
};
const TripCard = ({ trip, actualCheckStatusUrl })=>{
    let imageSrc, name, productName, brandImageUrl;
    const { type, title, dateHeader } = trip;
    name = title;
    const isPackage = type === productsType.PACKAGE;
    if (isPackage) {
        const { pkgType } = trip;
        productName = pkgType;
    } else {
        const { brandImageUrl: rcBrandImageUrl, type, header, imageUrl, scheduleInfo } = trip;
        imageSrc = imageUrl || scheduleInfo?.[0]?.companyLogoUrl;
        productName = products[type];
        name = name || header;
        brandImageUrl = rcBrandImageUrl;
    }
    return /*#__PURE__*/ jsx(Text, {
        lineHeight: "16px",
        children: /*#__PURE__*/ jsx(Card, {
            borderRadius: 16,
            p: 2,
            mb: 2,
            width: 1,
            color: "background.lightest",
            children: /*#__PURE__*/ jsxs(Flex, {
                width: 1,
                children: [
                    /*#__PURE__*/ jsx(Box, {
                        children: /*#__PURE__*/ jsx(Relative, {
                            height: "100%",
                            width: 1,
                            children: /*#__PURE__*/ jsx(Flex, {
                                height: "100%",
                                width: 1,
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                children: type ? imageSrc ? /*#__PURE__*/ jsxs(Flex, {
                                    width: '82px',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    children: [
                                        /*#__PURE__*/ jsx(StyledImage, {
                                            src: imageSrc,
                                            width: 'STAY' === type ? '82px' : null,
                                            borderRadius: "8px",
                                            height: 'STAY' === type ? '100%' : '29px'
                                        }),
                                        brandImageUrl ? /*#__PURE__*/ jsx(Image, {
                                            src: brandImageUrl,
                                            height: "13px"
                                        }) : null
                                    ]
                                }) : /*#__PURE__*/ jsx(BackUpImage, {
                                    type: type
                                }) : null
                            })
                        })
                    }),
                    /*#__PURE__*/ jsxs(Flex, {
                        flexDirection: "column",
                        pl: 3,
                        children: [
                            productName && /*#__PURE__*/ jsx(Text, {
                                color: "text.light",
                                fontSize: 0,
                                mb: 1,
                                children: productName
                            }),
                            name && /*#__PURE__*/ jsx(Flex, {
                                children: /*#__PURE__*/ jsx(CustomTruncate, {
                                    fontSize: 1,
                                    fontWeight: "bold",
                                    m: 0,
                                    mb: 1,
                                    children: name
                                })
                            }),
                            dateHeader && /*#__PURE__*/ jsx(Text, {
                                fontSize: 0,
                                color: "text",
                                mb: 1,
                                children: dateHeader
                            }),
                            actualCheckStatusUrl && /*#__PURE__*/ jsx(Link, {
                                target: "_blank",
                                href: actualCheckStatusUrl,
                                children: /*#__PURE__*/ jsx(Text, {
                                    fontSize: 0,
                                    children: "Select Trip"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
export { TripCard };
